import React, { useState, useRef } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Divider } from '@mui/material';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import break_box from '../../../../images/product/products.png';
const ViewPackage = ({ show, onClose, data }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
 
    const renderDays = () => {
        const days = [];
        const weekdays = [
            { key: 'sunday', label: 'Sun' },
            { key: 'monday', label: 'Mon' },
            { key: 'tuesday', label: 'Tue' },
            { key: 'wednesday', label: 'Wed' },
            { key: 'thursday', label: 'Thu' },
            { key: 'friday', label: 'Fri' },
            { key: 'saturday', label: 'Sat' },
        ];
        weekdays.forEach(day => {
            if (data?.timeline_details?.[day.key] === '0') {
                days.push(day.label);
            }
        });
        return days.join(', ');
    };
// Handle specification rendering
const renderSpecifications = () => {
    const specs = data?.specification;

    if (Array.isArray(specs) && specs.length > 0) {
        return specs.map((spec, idx) => {
            // Extract the specification text from the nested "specification" object
            const specText = spec?.specification?.specification || "Unknown specification";

            return (
                <div key={idx}>
                    <div className='d-flex align-items-start justify-content-start my-2'>
                        <div>
                            <i className="far fa-circle-check text-primary fs-3 me-2"></i>
                        </div>
                        <div className='fs-7 font-w400 text-black text-justify'>{specText}</div>
                    </div>
                    {idx < specs.length - 1 && <Divider />}
                </div>
            );
        });
    }



    // Fallback specification if not available
    return [
        "A mini tiffin is a compact, portable container perfect for carrying light meals or snacks on the go.",
        "A mini tiffin features multiple compartments to keep food items separate, preserving freshness and preventing flavor mixing.",
        "A good mini tiffin is leak-proof, made from durable materials, and may feature insulation to maintain food temperature for hours."
    ].map((item, idx) => (
        <div key={idx}>
            <div className='d-flex align-items-start justify-content-start my-2'>
                <div>
                    <i className="far fa-circle-check text-primary fs-3 me-2"></i>
                </div>
                <div className='fs-7 font-w400 text-black text-justify'>{item}</div>
            </div>
            {idx < 2 && <Divider />}
        </div>
    ));
};


    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Package</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-12 text-danger fs-5 text-center font-w600'>Break Box Mini Package</div>
                        <div className="d-flex align-items-center justify-content-start gap-3 mt-3">
                            <LightGallery
                                onInit={onInit}
                                speed={500}
                                plugins={[lgThumbnail, lgZoom]}
                            >
                                <div data-src={data?.product_image || break_box} className='border rounded px-1 py-0'>
                                    <img src={data?.product_image || break_box} alt="Break Box" className='cursor-pointer w-100px h-100px' />
                                </div>
                            </LightGallery>

                            <div className="d-flex flex-column">
                                <div className="d-flex align-items-center">
                                    <label className="text-black font-w400 fs-5">{data?.package_name || '-'}</label>
                                    <label className="text-black me-2 ms-2">|</label>
                                    <label className="text-black font-w400 fs-5">{data?.product_name || '-'}</label>
                                </div>
                                <div>
                                    <label className="text-black font-w400 fs-7">{data?.timeline_details?.packagetimeline_name || '-'} ({data?.timeline_details?.days || 0} Days)</label>
                                </div>
                                <div>
                                    <label className="text-black font-w400 fs-7">{data?.timeline_details?.all_days === 0 ? "All Days" : renderDays()}</label>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className='col-lg-12'>
                            <div className='border rounded mt-4 border-warning bgl-warning py-2'>
                                <p className="text-black fs-6 m-0 text-center">Selling Amount</p>
                                <p className="text-black fs-5 m-0">
                                    <div className='text-danger font-w600 fs-5 text-center'>
                                        <label><i class="fa-solid fa-indian-rupee-sign  me-2"></i></label>
                                        <label>{data?.selling_amount ? new Intl.NumberFormat('en-IN').format(data.selling_amount) : '0'}</label>
                                    </div>
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-12'>
                            <div className=' border rounded mt-4 border-info bgl-info py-2'>
                                <p className="text-black fs-6 m-0 text-center">Oneday Selling Amount</p>
                                <p className="text-black fs-5 m-0">
                                    <div className='text-danger font-w600 fs-5 text-center'>
                                        <label><i class="fa-solid fa-indian-rupee-sign  me-2"></i></label>
                                        <label>{data?.product_amount ? new Intl.NumberFormat('en-IN').format(data.product_amount) : '0'}</label>
                                    </div>
                                </p>
                            </div>
                        </div> 
                    </div>
                    <Divider></Divider>
                    <div className='row mt-2'>
                        <div className='col-lg-12 text-center mb-2'>
                            <label className='text-red fs-5 font-w600'>Specification</label>
                            <label className='text-black fs-5 font-w600 ms-2 me-2'>-</label>
                            <label className='badge bg-primary text-white fs-5 font-w600 px-1 py-0'>
                                {data?.specification?.length?.toString().padStart(2, '0') || '00'}
                            </label>
                        </div>
                        <div className='scroll-y min-h-200px mh-100px py-2'>
                            {renderSpecifications()}
                        </div>
                    </div>
                </div>
            </div >
        </Modal >
    );
};

export default ViewPackage;
